import React, { InputHTMLAttributes, useState } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";

import { Container, Error } from "./styles";
import { useField } from "@unform/core";
import { FiAlertCircle } from "react-icons/fi";

const animatedComponents = makeAnimated();

interface MultiSelectProps extends InputHTMLAttributes<HTMLSelectElement> {
    placeholder?: string| 'Selecione...';
    defaultValue?: any;
    options: Array<{ value: string; label: string; }>;
    onChange?: (selectedOptions: any) => void;
}


const customStyles = {
  control: (baseStyles: any, state: { isFocused: any; }) => ({
                ...baseStyles,
                borderColor: "transparent",
                borderRadius: "10px",
                minHeight: "20px",
                boxShadow: "-5px 5px 4px 0px rgba(0, 0, 0, 0.25)",

              }),
  multiValueLabel: (base: any) => ({
    ...base,
    whiteSpace: "normal", // Permite que o texto quebre linha
    overflow: "visible", // Evita que o texto seja cortado
  }),
  multiValue: (base: any) => ({
    ...base,
    maxWidth: "auto", // Permite que o chip expanda conforme necessário
    borderRadius: "10px",
  })
};



export const MultiSelect: React.FC<MultiSelectProps> = ({ name = '', ...props }) => {
    const { error } = useField(name);
  
    const handleSelect = (item: any) => {
      //setSelectedOptions(item);
      if (props.onChange) {
        props.onChange(item);
      }
    };
  
    return (
      <>
        <Container className="container-input" error={!!error}>
        {error && (
            <Error title={error}>
                <FiAlertCircle color="#c53030" size={20} />
            </Error>
            )}
          <Select
            name={name}
            value={props.defaultValue}
            components={animatedComponents}
            isMulti
            options={props.options}
            onChange={handleSelect}
            className="select"
            isClearable={true}
            isSearchable={true}
            isDisabled={false}
            isLoading={false}
            isRtl={false}
            closeMenuOnSelect={false}
            placeholder={props.placeholder}
            styles={customStyles}
          />
        </Container>
      </>
    );
  };
  


// export const MultiSelect = (props: any) => {
//   const [selectedOptions, setSelectedOptions] = useState([]);

//   const handleSelect = () => {
//     console.log(selectedOptions);
//   };

//   return (
//     <>
//     <Container className="container-input" error={false}>
//     <Select
//         name={props.name}
//         defaultValue={props.defaultValue}
//         components={animatedComponents}
//         isMulti
//         options={props.options}
//         onChange={(item: any) => setSelectedOptions(item)}
//         className="select"
//         isClearable={true}
//         isSearchable={true}
//         isDisabled={false}
//         isLoading={false}
//         isRtl={false}
//         closeMenuOnSelect={false}
//         styles={{
//             control: (baseStyles: any, state: { isFocused: any; }) => ({
//               ...baseStyles,
//               borderColor: "transparent",
//               borderRadius: "10px",
//               minHeight: "20px",
//               boxShadow:"-5px 5px 4px 0px rgba(0, 0, 0, 0.25)",
//             }),
//           }}
//       />
  
//     </Container>
      
//       <button onClick={handleSelect}>Imprimir itens</button>
//     </>
//   );
// };